<template>
  <v-toolbar v-bind="getConfigMenu.attributes" class="v-toolbar__content--custom">
    <v-toolbar-items ref="content" :class="[menuNavigation && 'v-toolbar__items--custom']">
      <template v-for="(item, index) in menu">
        <v-btn
          v-if="'children' in item === false"
          :key="index"
          text
          :class="[getCurrentActiveMenu === item.id && 'active']"
          @click="handleLoadRoute(item)"
          :id="`menu-${item.id}`"
        >
          <i v-if="item.icon" :class="[item.icon, 'icon-shake mr-1']"></i>
          {{ item.name }}
        </v-btn>

        <v-menu
          v-if="'children' in item === true"
          v-model="menuModel[index]"
          :key="index"
          offset-y
          origin="center center"
          transition="scroll-y-transition"
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on }">
            <v-btn :id="`menu-${item.id}`" text v-on="on" :class="[item.open === true && 'active']">
              <i v-if="item.icon" :class="[item.icon, 'icon-shake mr-1']"></i>
              {{ item.name }}
              <i class="zmdi zmdi-chevron-down ml-1"></i>
            </v-btn>
          </template>

          <i4proMenuDropdown
            class="i4pro-dropdown i4pro-dropdown--menu"
            :item="item"
            :menuModel="menuModel"
            :isScroll="true"
            @handleToggleDropdown="handleToggleDropdown"
          />
        </v-menu>
      </template>
    </v-toolbar-items>
    <v-btn icon text small dark @click="swipeLeft" class="icon-menu-left" v-if="menuNavigation">
      <v-icon>keyboard_arrow_left</v-icon>
    </v-btn>
    <v-btn icon text small dark @click="swipeRight" class="icon-menu-right" v-if="menuNavigation">
      <v-icon>keyboard_arrow_right</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
import { handleLoadRoute } from '@/helpers/page';
import store from '@/store';

export default {
  components: {
    i4proMenuDropdown: () => import('@/components/menus/i4pro-menu-dropdown')
  },

  data: () => ({
    menuModel: [],
    menuNavigation: false
  }),

  async created() {
    await store.dispatch('menu/getMenu');
  },

  mounted() {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth);
      this.getWindowWidth();
    });

    this.checkMenuScroll();
  },

  computed: {
    menu: () => {
      return store.getters['menu/getMenu'];
    },

    getCurrentActiveMenu: () => store.getters['menu/currentActiveMenu'],

    getConfigMenu: () => store.getters['layout/getConfigMenu']
  },

  methods: {
    handleLoadRoute,

    handleToggleDropdown() {
      for (let model in this.menuModel) {
        this.menuModel[model] = false;
      }
    },

    scrollTo(element, scrollPixels, duration) {
      const scrollPos = element.scrollLeft;
      if (!((scrollPos === 0 || scrollPixels > 0) && (element.clientWidth + scrollPos === element.scrollWidth || scrollPixels < 0))) {
        const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

        function scroll(timestamp) {
          const timeElapsed = timestamp - startTime;
          const progress = Math.min(timeElapsed / duration, 1);

          element.scrollLeft = scrollPos + scrollPixels * progress;

          if (timeElapsed < duration) {
            window.requestAnimationFrame(scroll);
          } else {
            return;
          }
        }

        window.requestAnimationFrame(scroll);
      }
    },

    swipeLeft() {
      const content = this.$refs.content;
      this.scrollTo(content, -300, 800);
    },

    swipeRight() {
      const content = this.$refs.content;
      this.scrollTo(content, 300, 800);
    },

    getWindowWidth(event) {
      let windowWidth = document.documentElement.clientWidth;
      this.checkMenuScroll(windowWidth);
    },

    checkMenuScroll(param) {
      let innerWidth = param ? param : window.innerWidth;
      let menu = document.querySelector('.v-toolbar__content--custom .v-toolbar__content .v-toolbar__items');

      if (menu && menu.clientWidth > innerWidth) {
        this.menuNavigation = true;
      } else {
        this.menuNavigation = false;
      }
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
  },

  watch: {
    $route(to) {
      to.path === '/dashboard' && store.dispatch('menu/setCurrentActiveMenu', this.menu[0].id);
    }
  }
};
</script>

<style lang="scss" scoped>
.v-menu__content {
  overflow-y: initial;
  overflow-x: initial;
  contain: initial;
  border-bottom: 3px solid var(--v-primary-base);
  z-index: 20 !important;
}
</style>
